<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改异步推送服务</span><span v-show="create">新增异步推送服务</span></h3>
            </el-col>
        </el-row>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-form-item label="服务名称" prop="serviceName">
                        <el-input ref="ipt01" v-model="form.serviceName" placeholder="请输入" maxlength="200" show-word-limit
                            ></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="请求地址" prop="requestUrl">
                            <el-input ref="ipt02" v-model="form.requestUrl" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="备用请求地址" prop="requestBackUrl">
                            <el-input ref="ipt03" v-model="form.requestBackUrl" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <!-- <el-form-item label="请求方式" prop="requestMode">
                            <el-select v-model="form.requestMode">
                                <el-option label="ws" value="01"></el-option>
                                <el-option label="http" value="02"></el-option>
                                <el-option label="https" value="03"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="请求方式" prop="requestMode">
                            <el-select v-model="form.requestMode" placeholder="请选择">
                                <el-option v-for="item in requestModeOptions" :key="item.value" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-form-item label="网络类型" prop="networkType">
                            <el-select v-model="form.networkType">
                                <el-option label="内网" value="01"></el-option>
                                <el-option label="互联网" value="02"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="网络类型" prop="networkType">
                            <el-select v-model="form.networkType" placeholder="请选择">
                                <el-option v-for="item in networkTypeOptions" :key="item.value" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <!-- <el-form-item label="请求数据格式" prop="requestDataType">
                            <el-select v-model="form.requestDataType">
                                <el-option label="xml" value="01"></el-option>
                                <el-option label="json" value="02"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="请求数据格式" prop="requestDataType">
                            <el-select v-model="form.requestDataType" placeholder="请选择">
                                <el-option v-for="item in requestDataTypeOptions" :key="item.value" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-form-item label="响应数据格式" prop="responseDataType">
                            <el-select v-model="form.responseDataType">
                                <el-option label="xml" value="01"></el-option>
                                <el-option label="json" value="02"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="响应数据格式" prop="responseDataType">
                            <el-select v-model="form.responseDataType" placeholder="请选择">
                                <el-option v-for="item in responseDataTypeOptions" :key="item.value" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="服务描述" prop="remark">
                            <el-input ref="ipt04" v-model="form.remark" placeholder="请输入" maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="版本号" prop="version">
                            <el-input ref="ipt04" v-model="form.version" placeholder="请输入" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="有效标志" prop="isValid">
                            <el-select v-model="form.isValid">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
   // import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity"],
        data() {
            let create = !this.entity.serviceNo
            let form
            if (create) {
                form = {
                    serviceName: "",
                    requestMode: "01",
                    requestUrl: "",
                    networkType: "01",
                    requestBackUrl: "",
                    requestDataType: "01",
                    responseDataType: "01",
                    remark: "",
                    version: "",
                    isValid: "Y"
                }
            } else {
                form = Object.assign({}, this.entity)
                console.log(this.entity)
            }
            let data = {
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                create,
                einvtypeCodeOptions: [],
                form,
                formRules: {
                    serviceName: [{
                            required: true,
                            message: "请输入服务名称",
                            trigger: "blur"
                        }, {
                            max: 200,
                            message: "最多200个字符",
                            trigger: "blur"
                        }
                    ],
                    requestUrl: [{
                            required: true,
                            message: "请输入请求地址",
                            trigger: "blur"
                        },
                        {
                            max: 200,
                            message: "最多200个字符",
                            trigger: "blur"
                        }
                    ],
                    requestBackUrl: [//备用请求地址
                        {
                            max: 200,
                            message: "最多200个字符",
                            trigger: "blur"
                        }
                    ],
                    remark: [//服务描述
                        {
                            max: 500,
                            message: "最多500个字符",
                            trigger: "blur"
                        }
                    ],
                    version: [//版本号
                        {
                            max: 20,
                            message: "最多20个字符",
                            trigger: "blur"
                        }
                    ]
                },
                requestModeOptions: [],
                networkTypeOptions: [],
                requestDataTypeOptions: [],
                responseDataTypeOptions: []
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit()
            }
        },
        created() {
            _kits = this.$kits();
            _kits.api.call( 
                "GETCOLLECTION", {
                   "collectionId": "notifyRequestModeEnumCollection"
                },
                result => {
                    if (result.returnCode == "0000") {
                        //console.log(result.data);
                        this.requestModeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call( 
                "GETCOLLECTION", {
                   "collectionId": "notifyNetworkTypeEnumCollection"
                },
                result => {
                    if (result.returnCode == "0000") {
                        //console.log(result.data);
                        this.networkTypeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call( 
                "GETCOLLECTION", {
                   "collectionId": "notifyDateTypeEnumCollection"
                },
                result => {
                    if (result.returnCode == "0000") {
                        //console.log(result.data);
                        this.requestDataTypeOptions = result.data;
                        this.responseDataTypeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            //this.queryYyOption();
            //this.queryDlOption();
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "ADDNOTIFYDETAILS" : "UPDATENOTIFYDETAILS"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
            //*/
        }
    }
</script>
